import { useTranslation } from "react-i18next";

import { TextInputType } from "../interfaces/edit-interfaces";
import { FilteringType } from "../interfaces";

type FilterInputType = "date" | TextInputType;
type IFilterLabelValue = ILabelValue<FilteringType>;

const filterOptions: IFilterLabelValue[] = [
    { label: "Exact", value: "__exact" },
    { label: "Includes", value: "__icontains" },
    { label: "Lower then", value: "__lt" },
    { label: "Lower or equal", value: "__lte" },
    { label: "Greater then", value: "__gt" },
    { label: "Greater or equal", value: "__gte" },
];

const textFilterOptions: IFilterLabelValue[] = [
    { label: "Includes", value: "__icontains" },
    { label: "Exact", value: "__exact" },
    { label: "not like", value: "__not_icontains" },
];

const dateFilterOptions: IFilterLabelValue[] = [
    { label: "Range", value: "__range" },
    { label: "Exact", value: "__date__exact" },
    { label: "Lower then", value: "__date__lt" },
    { label: "Lower or equal", value: "__date__lte" },
    { label: "Greater then", value: "__date__gt" },
    { label: "Greater or equal", value: "__date__gte" },
];

const selectFilterOptions: IFilterLabelValue[] = [
    { label: "Exact", value: "__exact" },
    { label: "not equals", value: "__ne" },
];

export const getFilterOptions = (type: FilterInputType): IFilterLabelValue[] => {
    const { t } = useTranslation();

    const translateOptions = (options) => options.map((option) => ({ ...option, label: t(option.label).firstLetterToUpperCase() }));

    switch (type) {
        case "text":
            return translateOptions(textFilterOptions);
        case "date":
            return translateOptions(dateFilterOptions);
        case "select":
            return translateOptions(selectFilterOptions);
        default:
            return translateOptions(filterOptions);
    }
};
